import { render, staticRenderFns } from "./tenant_config_history.vue?vue&type=template&id=5636cd02&scoped=true&"
import script from "./tenant_config_history.vue?vue&type=script&lang=js&"
export * from "./tenant_config_history.vue?vue&type=script&lang=js&"
import style0 from "./tenant_config_history.vue?vue&type=style&index=0&lang=css&"
import style1 from "./tenant_config_history.vue?vue&type=style&index=1&id=5636cd02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5636cd02",
  null
  
)

export default component.exports